import type { ReactNode } from "react";
import PageHeader from "./PageHeader";

export default function PartnerPageHeader({ title, subtitle, action }: { title: string; subtitle?: string; action?: ReactNode }) {
  return <PageHeader title={title} subtitle={subtitle} action={action} editorial />;
}
